import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Locals from "../Local/Locals";
import { Dynamic } from "../Context/ContextDynamic";
import OneBusiness from "./OneBusiness";
import { COLORS } from "../../COLORS";
import { useLocation, useNavigate } from "react-router-dom";

const Business = () => {
  const [texte, setTexte] = useState(
    "Ici sont publiées les publicités des entreprises locales."
  );
  const { partenairesImage } = Dynamic();
  const nav = useNavigate();
  const path = useLocation();
  const chooseComponent = () => {
    if (path.pathname === "/business") {
      return (
        <div className="business-pro">
          {partenairesImage &&
            partenairesImage.length > 0 &&
            partenairesImage.map((part, index) => (
              <OneBusiness
                key={index}
                id={part._id}
                urlImgCarre={part.urlImgCarre}
                linkRedirectionCarre={part.linkRedirectionCarre}
                urlImgRectangle={part.urlImgRectangle}
                linkRedirectionRectangle={part.linkRedirectionRectangle}
              />
            ))}
        </div>
      );
    } else {
      return <Locals />;
    }
  };

  useEffect(() => {
    if (path.pathname === "/business") {
      setTexte("Ici sont publiées les publicités des entreprises locales.");
    } else {
      setTexte("Ici sont publiées les porteurs de projets.");
    }
  }, [nav]);
  return (
    <StyledBusiness>
      <div className="btn-option">
        <button
          onClick={() => nav("/business")}
          className={path.pathname === "/business" ? "actif" : ""}
        >
          Pro actif
        </button>
        <button
          onClick={() => nav("/business/projets")}
          className={path.pathname === "/business/projets" ? "actif" : ""}
        >
          Projet
        </button>
        <button className="last-btn" onClick={() => nav("/post/business")}>
          Je fais ma pub
        </button>
      </div>
      <div className="component-chose">
        <p>{texte}</p>
        {chooseComponent()}
      </div>
    </StyledBusiness>
  );
};

export default Business;
const StyledBusiness = styled.section`
  .btn-option {
    width: 100%;
    padding: 10px;
    button {
      padding: 5px 20px;
      background: ${COLORS.main};
      color: ${COLORS.border_and_text_blue};
      outline: none;
      cursor: pointer;
      font-size: 1em;
      margin: 0px 15px;
    }
    .last-btn {
      border: none;
      border-radius: 5px;
      color: white;
      background: ${COLORS.orange_new};
      transition: 0.3s;
    }
    .last-btn:hover {
      background: ${COLORS.green};
    }
    .actif {
      border: solid 2px ${COLORS.border_and_text_blue};
    }
  }
  .component-chose {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    /* background: pink; */
    p {
      width: 100%;
      color: aliceblue;
    }
    .business-pro {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      /* background: white; */
    }
  }
  @media screen and (max-width: 445px) {
    padding-top: 20px;
    margin-top: 50px;
    .btn-option {
      .last-btn {
        margin-top: 10px;
      }
    }
    .component-chose {
      justify-content: center;
      padding: 5px 0px;
      .business-pro {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      }
    }
  }
`;
